import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import axroad from './modules/axroad'
import common from './modules/common'
import createLocation from './modules/createLocation'
import dashboard from './modules/dashboard'
import ecoscore from './modules/ecoscore'
import location from './modules/location'
import lsva from './modules/lsva'
import maintenance from './modules/maintenance'
import map from './modules/map'
import preferences from './modules/preferences'
import role from './modules/role'
import sharing from './modules/sharing'
import tracker from './modules/tracker'
import trip from './modules/trip'
import user from './modules/user'
import warnings from './modules/warnings'
import websocketPlugin from './plugins/websocket'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        axroad,
        common,
        createLocation,
        dashboard,
        ecoscore,
        location,
        lsva,
        maintenance,
        map,
        preferences,
        role,
        sharing,
        tracker,
        trip,
        user,
        warnings,
    },
    plugins: [websocketPlugin],
})
